const STATIC_DATA = {
    otherObj: {
      "areaId":2272,"areaIdd":"2272","areaName":"那曲",
      areaOther: [
        { areaid: 1, name: '安徽省' },
        { areaid: 2, name: '北京市' },
        { areaid: 3, name: '福建省' },
        { areaid: 4, name: '甘肃省' },
        { areaid: 5, name: '广东省' },
        { areaid: 6, name: '广西省' },
        { areaid: 7, name: '贵州省' },
        { areaid: 8, name: '海南省' },
        { areaid: 9, name: '河北省' },
        { areaid: 10, name: '河南省' },
        { areaid: 11, name: '黑龙江省' },
        { areaid: 12, name: '湖北省' },
        { areaid: 13, name: '湖南省' },
        { areaid: 14, name: '吉林省' },
        { areaid: 15, name: '江苏省' },
        { areaid: 16, name: '江西省' },
        { areaid: 17, name: '辽宁省' },
        { areaid: 18, name: '内蒙古' },
        { areaid: 19, name: '宁夏省' },
        { areaid: 20, name: '青海省' },
        { areaid: 21, name: '山东省' },
        { areaid: 22, name: '山西省' },
        { areaid: 23, name: '陕西省' },
        { areaid: 24, name: '上海市' },
        { areaid: 25, name: '四川省' },
        { areaid: 26, name: '天津市' },
        { areaid: 27, name: '西藏' },
        { areaid: 28, name: '新疆' },
        { areaid: 29, name: '云南省' },
        { areaid: 30, name: '浙江省' },
        { areaid: 31, name: '重庆市' }
      ],
      friendLinks: [
        { name: '全国招投标管理网', url: 'https://www.qianlima.com/jg1082703/' },
        { name: '全国政务网', url: 'https://www.qianlima.com/jg1042703/' },
        { name: '招标网', url: 'https://www.qianlima.com/' },
        {
          name: '成都盛邦百合房地产经纪有限公司',
          url: 'https://www.zhipin.com/zhaopin/10ae126b3011b9220n1729y5/'
        },
        {
          name: '全国公共资源交易中心',
          url: 'https://www.qianlima.com/01000202703aa/'
        },
        {
          name: '银焊条招标公告',
          url: 'https://www.qianlima.com/gjxx/2496/index_0_0.html'
        }
      ],
      hotLeixing: 'hot',
      keyword: '人力资源和社会保障局',
      nationalGuessYouLike: [
        { name: '药械集中采购网', id: 27 },
        { name: '建委招标办', id: 28 },
        { name: '移动招标网', id: 29 },
        { name: '联通招标网', id: 30 },
        { name: '电信招标网', id: 31 },
        { name: '施工招标', id: 32 },
        { name: '装饰工程招标', id: 33 },
        { name: '建设工程网', id: 34 },
        { name: '药品招标网', id: 35 },
        { name: '铁路局物资采购网', id: 36 },
        { name: '招标交易网', id: 37 },
        { name: '政府采购建设工程网', id: 39 },
        { name: '经济信息网', id: 40 },
        { name: '医疗器械招标网', id: 41 },
        { name: '水利招标信息网', id: 42 },
        { name: '政务', id: 43 },
        { name: '人力资源和社会保障局', id: 44 },
        { name: '交通运输执法局', id: 45 },
        { name: '商务局', id: 46 },
        { name: '采购中心', id: 47 }
      ],
      nowUrl: '/hot442703/',
      purchasingAgency: [
        { name: '东莞市宏霖五金橡胶制有限公司', id: 38026908 },
        { name: '青岛锐城智能设备有限公司', id: 38026907 },
        { name: '青岛德音化工有限公司', id: 38026906 },
        { name: '青岛乾泓盛机械有限公司', id: 38026905 },
        { name: '青岛绿荣园艺景观有限公司', id: 38026904 },
        { name: '青岛金庄天缘国际贸易有限公司', id: 38026903 },
        { name: '青岛博鑫七彩贝壳新型建材有限公司', id: 38026902 },
        { name: '青岛鸿鑫宇有限公司', id: 38026901 },
        { name: '青岛万仕和有限公司', id: 38026900 },
        { name: '青岛好富得包装有限公司', id: 38026899 }
      ],
      ssx: 'quanguo',
      wId: 44,
      wholeCountryCNXH: [
        { name: '塑钢', id: 475 },
        { name: '爆破', id: 583 },
        { name: '遮光布涂层', id: 10378 },
        { name: '双灯纸系列', id: 24496 },
        { name: '拉链塑料袋', id: 35155 },
        { name: '全涤化纤面料', id: 37755 },
        { name: '金叶瓜子黄杨', id: 49068 },
        { name: '金属挂件手链', id: 52230 },
        { name: '电加热蒸汽发生器', id: 52399 },
        { name: '五羊摩托车公主', id: 90402 },
        { name: '石头记', id: 96490 },
        { name: '挤奶机械设备', id: 97739 },
        { name: '韦德', id: 121750 },
        { name: '服装服饰行业', id: 126436 },
        { name: '喷油丝印设备', id: 135331 },
        { name: '硬胶囊剂', id: 149408 },
        { name: '木制圆规', id: 162628 },
        { name: '思域雨刮', id: 172017 },
        { name: '帆布购物袋环保袋', id: 192335 },
        { name: '七彩闪光灯', id: 226273 }
      ]
    },
    listObj: {
      areaName: "安徽",
      bodyData: [
        {
          keyworDescribe: "关键描述:",
          areaid: 301,
          areaName: "张掖市",
          contentid: 365218928,
          typeid: 57,
          inputtime: "2023-07-31",
          title: "中国电信张掖分公司2023-2025年非纸质宣传类及印刷类供应商服务采购项目比选公告（变更）",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230731_365218928.html",
          content:
            "比选文件 比选文件名称： 中国电信张掖分公司2023-2025年非纸质宣传类及印刷类供应商服务采购项目比选公告（变更） 创建时间日期： 2023-07-31 10:57:00 比选文件发售起始时间： 2023-07-29 09:00:00 比选文件发售截止时间： 2023-08-02 18:00:00 原公告编码： GSBXWJ20230728002 原公告...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 38,
          areaName: "合肥",
          contentid: 341333448,
          typeid: 52,
          inputtime: "2023-04-04",
          title: "安徽中医药大学第一附属医院笔架山广告渠道单位采购答疑澄清",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230404_341333448.html",
          content:
            "安徽中医药大学第一附属医院笔架山广告渠道单位采购答疑澄清 各潜在供应商： 第三章采购需求变更如下： 采购需求中计划年度需求实际为三年总需求，请各位供应商分项报价表按照附件一进行填写报价。 变更后采购需求（数量未变化） 序号 产品名称 规格型号材质 计划三年需求 单位 样图 1 条幅 牛津布机器烫印（包括安装）宽度：70CM 300 米 详见附件 2 彩色条幅...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 390,
          areaName: "深圳市",
          contentid: 337249617,
          typeid: 57,
          inputtime: "2023-03-16",
          title: "中共深圳市委党校教学印刷品印制服务项目更正公告",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230316_337249617.html",
          content:
            "一、项目基本情况 原公告的采购项目编号：CLF0123SZ02QY94 原公告的采购项目名称：中共深圳市委党校教学印刷品印制服务项目 首次公告日期：2023年3月10日 二、更正信息 更正事项：招标文件 更正内容： （一）原招标文件第三章 用户需求书四、★报价方式新增： 序号 服务内容 规格 单位 最高单价限价 52. 帆布资料袋 黑色帆布，印有党校LOGO...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 1334,
          areaName: "南京市",
          contentid: 337020423,
          typeid: 46,
          inputtime: "2023-03-15",
          title: "询价公告（变更）",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230315_337020423.html",
          content:
            "...m（单面） 2 岗位桌牌 20 张 无 南京明州码头有限公司 20*10cm（双面） 3 <a style='color:red;'>亚克力台卡</a> 20 个 无 南京明州码头有限公司 20...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 2703,
          areaName: "全国",
          contentid: 324904869,
          typeid: 58,
          inputtime: "2023-02-07",
          title: "透明亚克力台卡架立牌，A4桌摆款[LE-XJ-2302-95117]变更公告",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230207_324904869.html",
          content:
            "各投标人： 项目名称：透明<a style='color:red;'>亚克力台卡</a>架立牌，A4桌摆款 项目编号：LE-XJ-2302-95117 本项目的投标截止时间由2023年02月09日 14:05调整为2023年02月07日 08:40;开标时间由2023年02月09日 14:05调整为2023年02月07日 08:40; 由此给各投标人带来的不便，敬请谅解。 附件：( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 2267,
          areaName: "天津市",
          contentid: 320220474,
          typeid: 61,
          inputtime: "2023-01-12",
          title: "中国电信天津分公司2023-2024年智慧营业厅品牌升级项目比选公告（变更）",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20230112_320220474.html",
          content:
            "比选文件 比选文件名称： 中国电信天津分公司2023-2024年智慧营业厅品牌升级项目比选公告（变更） 创建时间日期： 2023-01-12 15:04:00 比选文件发售起始时间： 2023-01-11 17:30:00 比选文件发售截止时间： 2023-01-16 17:30:00 原公告编码： TJBXWJ20230111001 原公告名称： 中国电�( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 959,
          areaName: "齐齐哈尔",
          contentid: 255557125,
          typeid: 57,
          inputtime: "2021-12-29",
          title: "齐齐哈尔医学院附属第三医院宣传品喷绘制作定点服务采购采购更正公告（第一次）",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20211229_255557125.html",
          content:
            "齐齐哈尔医学院附属第三医院宣传品喷绘制作定点服务采购采购更正公告（第一次） 一、项目基本情况 原公告的采购项目编号：LYJT2021083 原公告的采购项目名称：宣传品喷绘制作定点服务采购 首次公告日期：2021年12月28日 二、更正信息： 更正事项：采购文件 更正原因： 补充政府采购政策落实的评审标准 更正内容： 采购文件第14页补充了对小型、微型企业、...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
        {
          keyworDescribe: "关键描述:",
          areaid: 501,
          areaName: "南宁市",
          contentid: 233983424,
          typeid: 58,
          inputtime: "2021-08-05",
          title: "景区标识标牌完善工作——景区基础设施配套标识牌制作安装及维修工作采购文件更正公告",
          progid: 2,
          url: "https://www.qianlima.com/zb/detail/20210805_233983424.html",
          content:
            "一、项目基本情况 原公告的采购项目编号：2021QXS-GCB-CG02 原公告的采购项目名称：景区标识标牌完善工作——景区基础设施配套标识牌制作安装及维修工作 首次公告日期：2021年8月4日 二、更正信息 更正事项：采购文件 更正内容：1、原采购需求清单章节中第二大点的第九小点“质保期要求：本次采购的标识牌的产品质保至少为壹年，中标后供应商也可在投标中增...( <span style='color: #EA0A00'>亚克力台卡</span> 在正文中 )",
        },
      ],
      keyword: "亚克力台卡",
      title: "迭部县人力资源和社会保障局",
      total: 9,
    },
  };
  export default STATIC_DATA;
  